var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgApproval = function SvgApproval(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-354 -1244C-354 -1299.23 -309.228 -1344 -254 -1344H31772C31827.2 -1344 31872 -1299.23 31872 -1244V10626C31872 10681.2 31827.2 10726 31772 10726H-254C-309.229 10726 -354 10681.2 -354 10626V-1244Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-254 -1343H31772V-1345H-254V-1343ZM31871 -1244V10626H31873V-1244H31871ZM31772 10725H-254V10727H31772V10725ZM-353 10626V-1244H-355V10626H-353ZM-254 10725C-308.676 10725 -353 10680.7 -353 10626H-355C-355 10681.8 -309.781 10727 -254 10727V10725ZM31871 10626C31871 10680.7 31826.7 10725 31772 10725V10727C31827.8 10727 31873 10681.8 31873 10626H31871ZM31772 -1343C31826.7 -1343 31871 -1298.68 31871 -1244H31873C31873 -1299.78 31827.8 -1345 31772 -1345V-1343ZM-254 -1345C-309.781 -1345 -355 -1299.78 -355 -1244H-353C-353 -1298.68 -308.676 -1343 -254 -1343V-1345Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 900,
    transform: "translate(-30 -291)",
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 900,
    transform: "translate(-30 -291)",
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -9,
    width: 216,
    height: 40,
    rx: 4,
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8213 6.20039L9.50745 1.40039L1.1936 6.20039V15.8004L9.50745 20.6004M17.8213 6.20039L9.50745 11.6004M17.8213 6.20039V11.0004M9.50745 20.6004V11.6004M9.50745 20.6004L11.3069 19.5615M9.50745 11.6004L1.70745 6.80039M13.1074 8.60039L5.30745 3.80039M13.4064 16.7004H16.1068M16.1068 16.7004H18.8064M16.1068 16.7004L16.1068 14.0004M16.1068 16.7004V19.4004",
    stroke: "#797979",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApproval);
export default ForwardRef;